import { EFetchNewbuildingsForPromoInventoryActionType } from './types';
import { INewbuildingForPromoInventory } from '../../types/promoInventory';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const setStatusSucceed = actionGenerator<
  EFetchNewbuildingsForPromoInventoryActionType.Succeed,
  INewbuildingForPromoInventory[]
>(EFetchNewbuildingsForPromoInventoryActionType.Succeed);
